import { createContext, useContext, useState, ReactNode } from 'react';

interface AppContextType {
  savedScriptIds: string[];
  bookmarkedNewsIds: string[];
  toggleSavedScript: (id: string) => void;
  toggleBookmarkedNews: (id: string) => void;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export function AppProvider({ children }: { children: ReactNode }) {
  const [savedScriptIds, setSavedScriptIds] = useState<string[]>([]);
  const [bookmarkedNewsIds, setBookmarkedNewsIds] = useState<string[]>([]);

  const toggleSavedScript = (id: string) => {
    setSavedScriptIds((prev) => 
      prev.includes(id) ? prev.filter(sId => sId !== id) : [...prev, id]
    );
  };

  const toggleBookmarkedNews = (id: string) => {
    setBookmarkedNewsIds((prev) => 
      prev.includes(id) ? prev.filter(nId => nId !== id) : [...prev, id]
    );
  };

  return (
    <AppContext.Provider value={{
      savedScriptIds,
      bookmarkedNewsIds,
      toggleSavedScript,
      toggleBookmarkedNews
    }}>
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
}
